import Router from 'vue-router';

let router = undefined;

const originalPush = Router.prototype.push;
Router.prototype.push = function push(location) {
    return originalPush.call(this, location).catch(err => err);
};

export function registerRouter(iRouter) {
    router = iRouter;
    return this;
}

export function getRouter() {
    return router;
}
